// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__x7QGh","pageButton":"Pagination_pageButton__MuEUK","active":"Pagination_active__A1yAv","disabled":"Pagination_disabled__VpqCD"};